import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import HealthMeasurementGauge from "@/features/MyHealth/components/HealthMeasurementGauge";
import {
  getHealthMeasurementValueRange,
  type HealthMeasurementQuestionType,
} from "@/services/core-api-adapter";
import { HealthMeasurementIdentifier } from "@/store";
import { getHealthMeasurementValueRangeColors } from "@/theme";

const SYSTOLIC_NUMBER_OF_TICKS = 71;

function getValueRangeWithColors() {
  const valueRange = getHealthMeasurementValueRange("SystolicBloodPressure");
  const colorMap = getHealthMeasurementValueRangeColors() as Record<
    string,
    Record<string, string>
  >;
  const key: HealthMeasurementQuestionType = "SystolicBloodPressure";
  return valueRange.map((item) => ({
    ...item,
    color: colorMap[key]?.[item.healthRiskIndicator],
  }));
}

export interface CurrentSystolicBPProps {
  value: number;
  unit?: string;
}

export default function CurrentSystolicBP({
  value,
  unit = "",
}: CurrentSystolicBPProps) {
  const { t } = useTranslation();
  const valueRange = useMemo(() => getValueRangeWithColors(), []);

  return (
    <Stack alignItems="center">
      <HealthMeasurementGauge
        healthMeasurementIdentifier={HealthMeasurementIdentifier.BloodPressure}
        value={value}
        unit={unit}
        valueRange={valueRange}
        numberOfTicks={SYSTOLIC_NUMBER_OF_TICKS}
      />
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          lineHeight: 1.25,
        }}
      >
        {t("HealthProfile.SystolicBloodPressure.detail.gauge.title")}
      </Typography>
    </Stack>
  );
}
